<template>
	<div class="mt-4" v-if="activeTabProp === 0">
		<vs-sidebar
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarEditActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("VisitPoints.UpdatePointofVisit") + validateIdentification }}</h4>
				<feather-icon
					icon="XIcon"
					class="cursor-pointer"
					@click.stop="isSidebarEditActive = false"
				></feather-icon>
			</div>
			<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
				<visit-point-edit
					v-if="isSidebarEditActive"
					name="visitPointEditPickup"
					ref="visitPointEditPickup"
					:data="visitPointObject"
					:activeTabProp="activeTabProp"
					@closeSidebarEmit="closeSidebar()"
					@visitPointListPickup="getDataVisitPoint"
				/>
			</vue-perfect-scrollbar>
		</vs-sidebar>
		<vs-collapse v-if="visitPoint.length > 0" id="VisitPointsItemPickup" type="border" :key="renderComponent">
			<vs-collapse-item v-for="(key, indexKey) in visitPoint" :key="indexKey" :open="isExpanded">
				<div slot="header">
					{{ key[0] === "undefined" || key[0] === "null" || key[0] === "" ? $t("NoGroupAssigned") : key[0] }}
				</div>
				<vs-list v-for="(item, index) in key[1]" :key="index">
					<vs-list-item
						:title="item.identification"
						:subtitle="item.time_service"
						:class="{'text-danger': showErrorOptimization(item)}"
					>
						<template slot="avatar">
							<vs-checkbox v-if="showChecked" color="success" v-model="item.checked"></vs-checkbox>
							<vs-avatar
								:color="showErrorOptimization(item) ? 'danger' : '#420D91'"
								icon-pack="feather"
								icon="icon-truck"
							/>
						</template>
						<div class="vx-row">
							<div v-if="showActions" class="vx-col w-full">
								<div class="flex flex-wrap items-center justify-end">
									<feather-icon
										icon="EditIcon"
										svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
										:title="
											showErrorOptimization(item) ? $t('ManualData.FixErrorsHere') : $t('Edit')
										"
										@click.prevent="editRecord(item, indexKey)"
									/>
									<feather-icon
										icon="FileTextIcon"
										svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
										:title="$t('SeeDetailedInformation')"
										@click="showInfo(item)"
									/>
									<feather-icon
										icon="Trash2Icon"
										svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
										:title="$t('Crud.Delete')"
										@click.prevent="removeAssignedVisitPoint(item, indexKey)"
									/>
								</div>
							</div>
							<div v-if="componentParent === 'GENERATE_REPEAT_PICKUP'" class="vx-col w-full">
								<div class="flex flex-wrap items-center justify-end">
									<feather-icon
										v-if="item.hasOwnProperty('cron') && item.hasOwnProperty('time_window_repeat')"
										icon="EyeIcon"
										svgClasses="h-6 w-6 mr-2 hover:text-primary cursor-pointer"
										:title="$t('ViewRepetitionFormatAndTimeWindow')"
										@click.prevent="activeSidebarDetailRepeat()"
									/>
									<feather-icon
										v-else
										icon="PlusSquareIcon"
										svgClasses="h-6 w-6 mr-2 hover:text-primary cursor-pointer"
										:title="$t('AddRepeatFormatAndTimeWindow')"
										@click.prevent="activeSidebarRepeat(item)"
									/>
								</div>
							</div>
						</div>
					</vs-list-item>
				</vs-list>
			</vs-collapse-item>
		</vs-collapse>
		<p class="mt-10 text-center font-semibold text-secondary" v-else>
			{{ textSearch(searchQueryPickup ? "search" : "") }}
		</p>
		<vs-popup
			class="vs-con-loading__container"
			:title="
				visitPointDetail && visitPointDetail.hasOwnProperty('original_identification')
					? $t('IdentificationOfOrigin') + ' ' + visitPointDetail.original_identification
					: $t('NoGroupAssigned')
			"
			:active.sync="showPopup"
		>
			<detail-visit-point-shipments :visit-point-detail="visitPointDetail" />
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import VisitPointEdit from "@/components/optimization/visit-point/edit/VisitPointEdit.vue";
import DetailVisitPointShipments from "./DetailVisitPointShipments.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	name: "ListSelectedVisitPointsItemPickup",
	components: {
		vSelect,
		flatPickr,
		VisitPointEdit,
		DetailVisitPointShipments,
		VuePerfectScrollbar,
	},
	props: {
		visit_point_selected: {
			type: Array,
			default: () => [],
		},
		activeTabProp: {
			type: Number,
			default: 0,
		},
		markerArray: {
			type: Object,
			default: () => {},
		},
		searchQueryPickup: {
			type: String,
			default: "",
		},
		showActions: {
			type: Boolean,
			default: true,
		},
		showChecked: {
			type: Boolean,
			default: false,
		},
		componentParent: {
			type: String,
			default: "LIST_SELECTED_VISIT_POINT_PICKUP",
		},
	},
	data() {
		return {
			isMounted: false,
			showPopup: false,
			isSidebarEditActive: false,
			visitPointObject: null,
			visitPointDetail: null,
			isExpanded: false,
			renderComponent: 0,
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		visitPoint() {
			return this.visit_point_selected === undefined ||
				this.visit_point_selected === "" ||
				this.visit_point_selected === null
				? []
				: this.visit_point_selected;
		},
		validateProperty() {
			return function (obj, propertyName) {
				if (Object.hasOwnProperty.call(obj, propertyName)) {
					return obj[propertyName];
				} else {
					return "";
				}
			};
		},
		validateIdentification() {
			return this.visitPoint.hasOwnProperty("identification") &&
				(this.visitPoint.identification != undefined ||
					this.visitPoint.identification != null ||
					this.visitPoint.identification != "")
				? `(${this.visitPoint.identification})`
				: "";
		},
		showErrorOptimization() {
			return (visitPoint) => {
				const errorFilter = this.$store.state.moduleOptimization.errorList.filter((data) => {
					return data.absolute_path[0] == "pickups" && data.absolute_path[1] === visitPoint.indexVisitPoint;
				});
				return errorFilter.length > 0;
			};
		},
		textSearch() {
			return (type) => {
				if (type === "search") return this.$t("NoResultsWereFoundForYourSearch");
				return this.$t("ThereIsNoDataToDisplayPleaseTryToAddNewRecords");
			};
		},
	},
	methods: {
		showInfo(item) {
			this.visitPointDetail = item;
			this.showPopup = true;
		},
		removeAssignedVisitPoint(visitPoint, index) {
			this.$store.commit("moduleOptimization/DELETE_VISIT_POINTS_SELECTED_PICKUP_STANDARD_INPUT", {
				visitPoint,
				indexVisitPoint: index,
			});
			this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_PICKUP", visitPoint);
			this.markerArray.features.forEach((m) => {
				if (m.properties.identification === visitPoint.identification) this.$emit("removeMarkerEmit", m);
			});
		},
		closeSidebar() {
			this.isSidebarEditActive = false;
		},
		editRecord(visitPoint, index) {
			this.visitPointObject = visitPoint;
			this.visitPointObject.indexVisitPoint = index;
			this.isSidebarEditActive = true;
		},
		toggleAll() {
			this.isExpanded = !this.isExpanded;
			this.$emit("getExpanded", this.isExpanded);
			this.renderComponent++;
		},
		activeSidebarRepeat(item) {
			this.$emit("isSidebarRepeat", true);
			this.$emit("visitPointPickup", item);
		},
		activeSidebarDetailRepeat() {
			this.$emit("isSidebarDetailRepeat", true);
		},
		getDataVisitPoint(val) {
			this.visitPoint.forEach(([groupKey, items]) => {
				const index = items.findIndex((item) => item.identification === val.identification);
				if (index !== -1) {
					// Verificar si los datos son iguales
					const currentItem = items[index];
					if (JSON.stringify(currentItem) === JSON.stringify(val)) {
						// Los datos son iguales, no realizar ninguna acción
						return;
					}
					// Actualizar solo si los datos son diferentes
					this.$set(items, index, val);
				}
			});
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
<style lang="scss">
#VisitPointsItemPickup {
	.vs-collapse-item--header {
		color: rgba(var(--vs-dark), 1);
		font-weight: bold;
		font-size: 17px;
	}
}
.scroll-area--form {
	height: calc(100vh - 70px);
	min-height: 0;
	max-height: calc(100vh - 70px);
	overflow-y: auto;
}
</style>
